var lib_core = require("lib-core");

var RestrictData = function (shape, type, onTopLayer, onBottomLayer, onInnerLayers) {
    var self = this;

    this.makeObservableTreeNode();

    this.shape = this.value("shape", true);

    this.type = this.value("type", true); // COMPONENT VIA COPPER

    this.onTopLayer = this.value("onTopLayer", true);
    this.onBottomLayer = this.value("onBottomLayer", true);
    this.onInnerLayers = this.value("onInnerLayers", true);

    if(shape != undefined) this.shape(shape);
    if(type != undefined) this.type(type);
    if(onTopLayer != undefined) this.onTopLayer(onTopLayer);
    if(onBottomLayer != undefined) this.onBottomLayer(onBottomLayer);
    if(onInnerLayers != undefined) this.onInnerLayers(onInnerLayers);

    var addShapeShadows = function () {
        if(self.shape()) {
            self.geometry = self.shape().geometry;
            self.segmentedGeometry = self.shape().segmentedGeometry;
            self.boundingBox = self.shape().boundingBox;
        }
    };

    if(this.shape()) addShapeShadows();
    this.shape.onChange("shapeChanged", addShapeShadows);
};
lib_core.mixin(RestrictData, lib_core.ObservableTreeNode);

lib_core.JsonParser.registerClass(RestrictData, "Restrict");

module.exports = RestrictData;

RestrictData.prototype.move = function (vec) {
    return this.shape() && this.shape().move(vec);
};

RestrictData.prototype.rotate = function (angle) {
    return this.shape() && this.shape().rotate(angle);
};

RestrictData.prototype.flip = function (flipline) {
    return this.shape() && this.shape().flip(flipline);
};

